const GiftIcon = ({ className = "text-primary" }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="19"
      viewBox="0 0 18 19"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1983_6760)">
        <path
          d="M2.25 7.25C2.25 7.05109 2.32902 6.86032 2.46967 6.71967C2.61032 6.57902 2.80109 6.5 3 6.5H15C15.1989 6.5 15.3897 6.57902 15.5303 6.71967C15.671 6.86032 15.75 7.05109 15.75 7.25V8.75C15.75 8.94891 15.671 9.13968 15.5303 9.28033C15.3897 9.42098 15.1989 9.5 15 9.5H3C2.80109 9.5 2.61032 9.42098 2.46967 9.28033C2.32902 9.13968 2.25 8.94891 2.25 8.75V7.25Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 6.5V16.25"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 9.5V14.75C14.25 15.1478 14.092 15.5294 13.8107 15.8107C13.5294 16.092 13.1478 16.25 12.75 16.25H5.25C4.85218 16.25 4.47064 16.092 4.18934 15.8107C3.90804 15.5294 3.75 15.1478 3.75 14.75V9.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.625 6.50033C5.12772 6.50033 4.65081 6.30278 4.29917 5.95115C3.94754 5.59952 3.75 5.12261 3.75 4.62533C3.75 4.12805 3.94754 3.65113 4.29917 3.2995C4.65081 2.94787 5.12772 2.75033 5.625 2.75033C6.34851 2.73772 7.05752 3.08877 7.65955 3.7577C8.26158 4.42662 8.72871 5.38238 9 6.50033C9.27129 5.38238 9.73841 4.42662 10.3404 3.7577C10.9425 3.08877 11.6515 2.73772 12.375 2.75033C12.8723 2.75033 13.3492 2.94787 13.7008 3.2995C14.0525 3.65113 14.25 4.12805 14.25 4.62533C14.25 5.12261 14.0525 5.59952 13.7008 5.95115C13.3492 6.30278 12.8723 6.50033 12.375 6.50033"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1983_6760">
          <rect
            fill="white"
            height="18"
            transform="translate(0 0.5)"
            width="18"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GiftIcon;
